export default "__VITE_ASSET__CleW3i1Z__"